import React, { Component } from "react";
import PropTypes from "prop-types";
import ChatIcon from "./ChatIcon";

class LeavingQueueView extends Component {
  render() {
    return /*#__PURE__*/React.createElement("div", {
      id: "queue-view"
    }, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement(ChatIcon, {
      className: "large"
    }), /*#__PURE__*/React.createElement("span", {
      className: "dpd-customer-services"
    }, "DPD Customer Services")), /*#__PURE__*/React.createElement("div", {
      className: "message"
    }, /*#__PURE__*/React.createElement("span", {
      className: "whoa-there"
    }, "Whoa there!"), /*#__PURE__*/React.createElement("span", {
      className: "if-leave-now"
    }, "If you leave now you will lose your place in the queue")), /*#__PURE__*/React.createElement("div", {
      id: "leaving-queue"
    }, /*#__PURE__*/React.createElement("button", {
      onClick: this.props.onLeave
    }, "Leave the queue"), /*#__PURE__*/React.createElement("button", {
      className: "flat-white-reverse",
      onClick: this.props.onBack
    }, "Stay in the queue")));
  }

}

LeavingQueueView.propTypes = {
  onLeave: PropTypes.func,
  onBack: PropTypes.func
};
export default LeavingQueueView;